import { render, staticRenderFns } from "./FontPairingEdit.vue?vue&type=template&id=b9f421f4"
import script from "./FontPairingEdit.vue?vue&type=script&lang=js"
export * from "./FontPairingEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports